import React from 'react'

import LearningGroupListApp from 'app/LearningGroupPage/LearningGroupList'
import { getDeviceId } from 'utils/deviceId'

export async function getServerSideProps(ctx) {
  return {
    props: {
      appDeviceID: getDeviceId(ctx),
    },
  }
}

const LearningGroupPage = () => {
  return <LearningGroupListApp />
}

export default LearningGroupPage
